import React from "react";
import { useSelector } from "react-redux";
import { selectConfig } from "../features/config/ConfigSlice";

function HeaderLogo() {
  const { components } = useSelector(selectConfig);
  if (components.Images.HeaderLogo.display) {
    return (
      <a
        className="header-logo-container"
        href={components.Images.HeaderLogo.link}
        target={components.Images.HeaderLogo.target}
      >
        <div className="header-logo" />
      </a>
    );
  } else {
    return null;
  }
}

export default HeaderLogo;
